export default __webpack_public_path__ + "static/media/SortUpArrow.ff721c30.svg";